export const footerContainer = "MiscCss_footerContainer";
export const footerBtn = "MiscCss_footerBtn";
export const footerLogoIcon = "MiscCss_footerLogoIcon";
export const footerLogoText = "MiscCss_footerLogoText";
export const footerLinks = "MiscCss_footerLinks";
export const footerDetails = "MiscCss_footerDetails";
export const footerContactRow = "MiscCss_footerContactRow";
export const SquareGridGrid = "MiscCss_SquareGridGrid";
export const spinnerContainer = "MiscCss_spinnerContainer";
export const spinnerContainerLarge = "MiscCss_spinnerContainerLarge";
export const headContainer = "MiscCss_headContainer";
export const headSpacer = "MiscCss_headSpacer";
export const headTransparent = "MiscCss_headTransparent";
export const headerLeft = "MiscCss_headerLeft";
export const headerLeftMoreBtn = "MiscCss_headerLeftMoreBtn";
export const headerCenter = "MiscCss_headerCenter";
export const headerCenterLogoText = "MiscCss_headerCenterLogoText";
export const headerCenterTitle = "MiscCss_headerCenterTitle";
export const headerRight = "MiscCss_headerRight";
export const pageMarginsContainer = "MiscCss_pageMarginsContainer";
export const pageBottomPaddingContainer = "MiscCss_pageBottomPaddingContainer";
export const pageMarginsInnerContainer = "MiscCss_pageMarginsInnerContainer";
export const pageMarginsFillToSideBar = "MiscCss_pageMarginsFillToSideBar";
export const pageMarginsInnerContainerFillToSideBar = "MiscCss_pageMarginsInnerContainerFillToSideBar";
export const pageMarginsLarge = "MiscCss_pageMarginsLarge";
export const pageMarginsSmall = "MiscCss_pageMarginsSmall";
export const pageTitleContainer = "MiscCss_pageTitleContainer";
export const pageTitleMain = "MiscCss_pageTitleMain";
export const pageTitleMainAnimation = "MiscCss_pageTitleMainAnimation";
export const pageTitleSub = "MiscCss_pageTitleSub";
export const pageTitleSubAnimation = "MiscCss_pageTitleSubAnimation";
export const outlineBtn = "MiscCss_outlineBtn";
export const primaryBtn = "MiscCss_primaryBtn";
export const primaryBtnWhite = "MiscCss_primaryBtnWhite";
export const primaryBtnYellow = "MiscCss_primaryBtnYellow";
export const primaryBtnBlack = "MiscCss_primaryBtnBlack";
export const outlineBtnWhite = "MiscCss_outlineBtnWhite";
export const outlineYellowBtn = "MiscCss_outlineYellowBtn";
